// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"cd602fe4","352":"c3b7dffe","453":"4bff0fc0","551":"823f4d0b","633":"fe69086b"}[chunkId] + ".chunk.js";
};